import axios, { AxiosRequestConfig } from 'axios'

const API_BASE_URL = 'https://vn-api.unicity.com/mlm/api'
const HYDRA_BASE_URL = 'https://hydra.unicity.net'

// Create axios instance with default config
export const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
})

// Create hydra client for external API calls
export const hydraClient = axios.create({
    baseURL: HYDRA_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
})

// Helper to create authorized hydra request
export const createHydraRequest = (token: string): AxiosRequestConfig => ({
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
})

// Convert VN API href to Hydra href
export const toHydraHref = (vnHref: string): string => {
    return vnHref.replace('https://vn-api.unicity.com', HYDRA_BASE_URL)
}

